<template>
  <div id="">
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.name" placeholder="关键字查询"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="el-form-button" type="primary" v-on:click="getPages">查询</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <el-table :data="infoList"
              row-key="typeCode"
              @expand-change="handleExpendRow"
              style="width: 100%">
      <el-table-column type="expand" align="center">
        <template slot-scope="props">
          <el-table :header-cell-style="headerStyle" :data="props.row.dicts">
            <el-table-column prop="company" label="厂家"></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column prop="price" label="单价"></el-table-column>
            <el-table-column prop="num" label="进货数量"></el-table-column>
            <el-table-column prop="totalPrice" label="进货总价"></el-table-column>
            <el-table-column prop="remainNum" label="剩余数量"></el-table-column>
            <el-table-column prop="reaminTotalPrice" label="剩余总价"></el-table-column>
            <el-table-column prop="modifyTime" label="操作时间"></el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="typeCode" label="类型编码" min-width="120"></el-table-column>
      <el-table-column prop="typeName" label="商品类型" min-width="180"></el-table-column>
      <el-table-column prop="totalNum" label="进货总数" min-width="120"></el-table-column>
      <el-table-column prop="totalCost" label="成本总价" min-width="120"></el-table-column>
      <el-table-column prop="remainNum" label="剩余总数" min-width="120"></el-table-column>
      <el-table-column prop="remainCost" label="剩余成本" min-width="120"></el-table-column>
    </el-table>
    <div class="pagination" style="text-align: right; padding-right: 19px; padding-top: 7px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageNum"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
    api
} from '../../api/login';
import axios from 'axios';
import qs from 'qs';
export default {
    data() {
        return {
            filters: {
              name: ''
            },
            infoList: [],
            cur_page:1,//默认在第一页
            pageNum:10,//默认每页显示1条数据
            totalCount:1 //默认总条数为一条
        }
    },
    mounted: function () {
        this.loadData();
    },
    methods: {
        handleSizeChange(val) {
          this.pageNum=val;//获取page-sizes里的每页显示几条数据的值，赋给我们自定义的每页显示数量的变量pageNum
          this.loadData();//展示页面信息
        },
        handleCurrentChange(val) {
          this.cur_page = val;
          this.loadData();//确定当前页面后刷新页面
        },
        loadData() {
            let param = {current:this.cur_page,size:this.pageNum,filter:this.filters.name};
            axios.post('/yogaInport/stock', param).then((result) => {
                //console.info(result);
                if(result.data.code == 0){
                    var _data = result.data.data.records;
                    this.infoList = _data;
                    this.cur_page=result.data.data.current;//默认在第一页
                    this.pageNum=result.data.data.size;//默认每页显示1条数据
                    this.totalCount=result.data.data.total;//默认总条数为一条
                }else{
                  this.$message({
                    type: 'error',
                    message: `查询数据失败`
                  });
                }
            });
        },
        getPages() {
            this.loadData();
        },
        handleExpendRow(row) { //这里是点击每一行会触发的方法
          if (!row.dicts) { //这里做了一个判断，首先判断这一行的数据对象有没有dicts这个属性，如果没说明没有数据我们需要请求后台，相当于懒加载
            this.queryDictData(row.typeCode) //关键就是这个方法，row.id是父分组的id需要传给后台查询该子分组的信息
          }
        },
        queryDictData(id) {
          let self = this
          axios.get('/yogaInport/stock/'+id).then((result) => {
            const index = self.infoList.findIndex(data => data.typeCode === id)
            if(result.data.code == 0){
              var list = result.data.data;
              /*if (list && list.length) {
                list.forEach(item => { //这里我是给每个子分组信息里都加上父分组的id，以方便后面操作子表格每一行后，回调函数里刷新数据时需要用到，要知道他的父亲是谁，哈哈
                  item.labelId = id
                })
              }*/
              self.$set(self.infoList[index], 'dicts', list) //这里就是给父表格数据数组self.pageData.results第index个对象加上dicts这个属性，然后把rspData.data我们从后台拿到的数据绑定到dicts这个key里
            }else{
              this.$message({
                type: 'error',
                message: `查询数据失败`
              });
            }
          });
        },



        headerStyle(){
          return 'background:#FFE4C4;';
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/yoga/YogaStock.vue